<template>
  <div class="m-2">
    <flip-card
        v-for="item in list"
        :key="item.id"
        :id="item.id.toString()"
        :title="item.title"
        :description="item.description"
        :episodes="item.episodes"
        :uncensored="item.uncensored"
        :thumbnail="item.thumbnail"
        :covers="item.covers"
        :mal="item.mal"
        :anidb="item.anidb"
        :dark-mode="darkMode"
    ></flip-card>
  </div>
</template>

<script>
import {route} from "@/constants";
import FlipCard from "@/components/FlipCard";
import {mapGetters} from "vuex";

export default {
  name: 'Covers',
  components: {FlipCard},
  props: {
    darkMode: Boolean,
    list: Array
  },
  beforeMount() {
    if (this.currentUser.homePage === route.LIST) {
      this.$router.push({name: route.LIST});
    }
  },
  computed: {
    ...mapGetters([
      "currentUser"
    ])
  }
}
</script>
